import { DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { useTranslation } from 'react-i18next';

export function DropdownMenuItemEmpty() {
  const { t } = useTranslation();
  return (
    <DropdownMenuItem>
      <div className="text-center justify-start text-neutrals-N700 text-sm font-normal leading-tight">
        {t('domain.navigation.benachrichtigungen.empty')}
      </div>
    </DropdownMenuItem>
  );
}
